import PropTypes from 'prop-types';
import { intlMessageShape } from './intlMessageShape';
export const contextPropType = {
  path: PropTypes.string,
  title: intlMessageShape,
  exact: PropTypes.bool,
  match: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)])
};
export const contextShape = PropTypes.shape(contextPropType);
export const contextSwitcherPropTypes = {
  defaultLabel: intlMessageShape,
  values: PropTypes.arrayOf(contextShape.isRequired).isRequired
};
export const contextSwitcherShape = PropTypes.shape(contextSwitcherPropTypes);